import { NotifyHelper } from '../../../helpers/toast';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { ePhongNamHocActionTypesIds, IPhongNamHocActionTypes } from '../../action-types/danh-muc/IPhongNamHocActionTypes';
import { IPhongNamHocPageState } from '../../page-state-model/danh-muc/IPhongNamHocPageState';

const initialState: IPhongNamHocPageState = {
    status: ePageBaseStatus.is_not_initialization,
    noitru_phong_namhocs: [],
    noitru_phong_namhoc_selected_ids: [],
    noitru_phong_namhoc_editing: undefined,
    is_show_delete_confirm: false,
    is_show_detail_modal: false,
};

export const phongNamHocReducer = (state: IPhongNamHocPageState = initialState, action: IPhongNamHocActionTypes): IPhongNamHocPageState => {
    switch (action.type) {
        case ePhongNamHocActionTypesIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            };
        case ePhongNamHocActionTypesIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                noitru_phong_namhocs: action.payload,
            };
        case ePhongNamHocActionTypesIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                noitru_phong_namhocs: [],
            };
        case ePhongNamHocActionTypesIds.SELECT_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            };
        case ePhongNamHocActionTypesIds.SELECT_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                noitru_phong_namhocs: action.payload,
            };
        case ePhongNamHocActionTypesIds.SELECT_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                noitru_phong_namhocs: [],
            };
        default:
            return state;
    }
};
